import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Typography, Box, Container } from '@mui/material';
//Custom components
import { UseImage, Buttons, CustomLoadingOverlay, GenericContainer } from '../../components';
import { fileActions, addTitleLegoCurrent } from '../../store/actions';
import { useTranslation } from 'react-i18next';
import EncuestaImg from '../../assets/EncuestaP1.png';

export default function StartSurvey({ nextView }) {
  const location = useLocation();
  const [loadView, setLoadView] = useState(false);
  const [propsStage, setPropsStage] = useState({
    title: 'Encuesta',
    icon: 'IconoEncuestaP1',
    description: '',
    buttonText: 'Continuar',
  });

  let idUser = sessionStorage.getItem('IdUserData');
  const file = useSelector((state) => state.FileInfo);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(addTitleLegoCurrent(t('info_solicitud_title')));
    dispatch(fileActions.GetFileInfo(idUser ? idUser : location.state?.folioId)); 
  }, []);

  useEffect(() => {
    setLoadView(file.loading);
    if (file.items != undefined) {
      let title = file.items.Stage.Properties.find((el) => el.Name === 'TitleP1');
      let icon = file.items.Stage.Properties.find((el) => el.Name === 'IconNameP1');
      let description = file.items.Stage.Properties.find((el) => el.Name === 'DescriptionP1');
      let buttonText = file.items.Stage.Properties.find((el) => el.Name === 'ButtonTextP1');

      dispatch(addTitleLegoCurrent(title?.Value));
      setPropsStage({
        title: title?.Value || "Encuesta",
        icon: icon?.Value || "IconoEncuestaP1",
        description: description?.Value || "",
        buttonText: buttonText?.Value || "Continuar",
      });
    }
  }, [file]);

  const content = (
    <Container
      maxWidth="sm"
      sx={{
        height: 'calc(100vh - 11rem)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {loadView && (
        <CustomLoadingOverlay active={loadView} text={t('general_loading_advancedsign')} />
      )}
      <Box display="flex" justifyContent="center" width="100%">
        <UseImage style={{ maxWidth: 300 }} src={EncuestaImg} />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 3, alignItems: 'center' }}>
        <Typography>{propsStage.description}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, alignItems: 'center' }}>
        <Buttons
          ConfirmButtonText={propsStage.buttonText}
          onClickConfirm={() => nextView('SURVEY')}
        />
      </Box>
    </Container>
  );

  return <GenericContainer>{content}</GenericContainer>;
}
